export default __webpack_public_path__ + "static/media/avatar-placeholder.274b60f5.png";